import { PersistedValue } from './PersistedValue';
import { PersistedValueBuilder } from './PersistedValueBuilder';
export class PersistedValueConfigurationProvider {
    constructor(currentVersion = '1.0', defaultTTL = PersistedValueBuilder.getDurationInSeconds(1, 'month')) {
        this.currentVersion = currentVersion;
        this.defaultTTL = defaultTTL;
    }
    getValue(rawPersistedValue) {
        const persistedValue = PersistedValueBuilder.from(rawPersistedValue);
        if (persistedValue === undefined) {
            return undefined;
        }
        return persistedValue.getValueIfValid();
    }
    createRawPersistedValue(key, value, ttl) {
        return new PersistedValue(key, value, this.currentVersion, ttl === undefined ? this.defaultTTL : ttl).get();
    }
}
//# sourceMappingURL=PersistedValueConfigurationProvider.js.map